import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { PipesSharedModule as PipesModule } from './pipes/pipes.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './modules/material.module';
import { DirectiveModule } from './directives/directive.module';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    DirectiveModule,
    FlexLayoutModule,
    FormsModule,
    MaterialModule,
    PipesModule,
    ReactiveFormsModule,
    NgxSkeletonLoaderModule,
    TranslateModule,
  ],
  declarations: [],
  exports: [
    CommonModule,
    DirectiveModule,
    FlexLayoutModule,
    FormsModule,
    MaterialModule,
    PipesModule,
    ReactiveFormsModule,
    NgxSkeletonLoaderModule,
    TranslateModule,
  ],
})
export class SharedModule {}
